import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { currentUser, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <header className="header" style={{ position: 'fixed' }}>
      <div className="header-content" style={{ position: 'relative' }}>
        <div className="header-left">
          <div className="header-title-section">
            <div className="header-text">
              <h1 className="header-title">Application Portfolio Rationalization</h1>
            </div>
          </div>
        </div>
        <img
          src="/Rehlko_logo.png"
          alt="Rehlko"
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            height: '80px',
            objectFit: 'contain',
          }}
        />
        <div className="header-right">
          <div className="header-actions">
            <div className="version-section" style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px 16px 4px 32px',
              borderLeft: '1px solid #dee2e6',
              marginRight: '16px',
              textAlign: 'center'
            }}>
              <span style={{
                fontSize: '12px',
                color: '#6c757d',
                fontWeight: '400'
              }}>
                Version
              </span>
              <span style={{
                fontSize: '12px',
                color: '#495057',
                fontWeight: '400'
              }}>
                1.0.0
              </span>
            </div>
            {currentUser && (
              <div className="user-info">
                <button className="header-button logout" onClick={handleLogout}>
                  Log Out
                </button>
                <div className="current-user" title={`${currentUser.name} (${currentUser.role})`}>
                  {currentUser.name} ({currentUser.role})
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;